import React, { useEffect } from 'react';

import { Scrollbar } from '@/components/Scrollbar';
import { Logo } from '@/components/shared/Logo';
import { useStatusBar } from '@/hooks/useStatusBar';
import constants from '@/theme/exportedVariables.module.scss';
import { IonPage } from '@ionic/react';

import './PublicLayout.scss';

interface IProps {
	renderHeader?: JSX.Element;
	renderFooter?: JSX.Element;
	logo?: JSX.Element;
}

export const PublicLayout: React.FC<IProps> = ({
	children,
	renderHeader,
	renderFooter,
	logo,
}) => {
	const { setStatusBarColor } = useStatusBar();
	useEffect(() => {
		setStatusBarColor(constants.colorAsaphWhite, constants.colorDark1);
	});

	return (
		<IonPage>
			<Scrollbar className="authentication-scrollable">
				<div className="authentication">
					{!!renderHeader && (
						<div className="authentication-header">
							{renderHeader}
						</div>
					)}
					<div className="authentication-content">
						<div className="authentication-content__logo">
							{logo || <Logo />}
						</div>
						<div className="authentication-content__form">
							{children}
						</div>
					</div>
					{!!renderFooter && (
						<div className="authentication-footer">
							{renderFooter}
						</div>
					)}
				</div>
			</Scrollbar>
		</IonPage>
	);
};
